<div class="modal-header">
    <h4 class="modal-title">{{title}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="dismiss()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <p>
        {{message}}
    </p>
    <form [formGroup]="form">
        <div class="form-group">
            <label for="name">{{fieldName}}</label>
            <textarea placeholder="Put your comment here ..." formControlName="fieldValue" name="fieldValue" class="form-control"
            [ngClass]="{ 'is-invalid': form.controls.fieldValue.errors && (form.controls.fieldValue.dirty || form.controls.fieldValue.touched) }"></textarea>
        </div>
        <div *ngIf="form.controls.fieldValue.errors && (form.controls.fieldValue.dirty || form.controls.fieldValue.touched)"
            class="cross-validation-error-message alert alert-danger">
            <div *ngIf="form.controls.fieldValue.errors?.required">
                {{fieldName}} is required.
            </div>
        </div>
    </form>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="accept(form.controls.fieldValue.value)"
        [disabled]="form.invalid">Accept</button>
    <button type="button" class="btn btn-secondary" (click)="dismiss()">Cancel</button>
</div>